import React from "react";

const Collab = () => {
  return <></>;
};

export default Collab;
